import { MessageCircle } from 'lucide-react';
import { supportData } from '../../../../../utils/supportHelpers';

const EmptyChatView = () => {
  return (
    <div className="flex-1 flex flex-col items-center justify-center p-12 text-center space-y-3">
      <div className="w-16 h-16 rounded-3xl bg-[#067978]/10 text-[#067978] flex items-center justify-center">
        <MessageCircle size={32} />
      </div>
      <h3 className="text-base font-bold text-gray-900">
        {supportData.emptyStates.selectChat.title}
      </h3>
      <p className="text-xs text-gray-400 max-w-sm">
        {supportData.emptyStates.selectChat.description}
      </p>
    </div>
  );
};

export default EmptyChatView;
